import axios from "axios";

const loadUsers = (callback) => {
    const config = {
        url: '/api/users',
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data));
}

const deleteUser = (id, callback) => {
    const config = {
        url: `/api/users/${id}`,
        method: 'DELETE',
    }

    axios.request(config).then(response => callback(response.data));
}

const getUser = (userId, callback) => {
    const config = {
        url: `/api/users/${userId}`,
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data));
}

const save = (data, callback) => {
    const {id} = data;

    const config = {
        url: id ? `/api/users/${id}` : '/api/users',
        method: id ? 'PUT' : 'POST',
        data: data
    }

    axios.request(config).then(res => callback(res.data));
}

const UserActions = {
    loadUsers,
    getUser,
    save,
    deleteUser
}

export default UserActions